import React from "react";

import { Typography } from "@mui/material";

const calculateTotalTime = (recipe) => {
  let totalMins = 0;

  if (recipe && recipe.timing && recipe.timing.total) {
    totalMins = recipe.timing.total.hours * 60 + recipe.timing.total.minutes;
  }

  return totalMins;
};

//TO DO:
//Minimum necessary for recipe is servings and nutrition. Show this on the miniumum. If calories per serving specified, show that too
const RecipeQuickNutrition = ({ recipe }) => {
  return (
    <div className={`flex flex-row justify-between p-4 bg-neutral-100 md:px-8`}>
      {recipe && recipe.nutrition && recipe.nutrition.macros && recipe.nutrition.macros.calories && (
        <div className="flex flex-col items-center">
          <Typography variant="subtitle1" className="font-medium">
            Calories/serv
          </Typography>
          <Typography variant="subtitle2" className="font-normal">
            {recipe.nutrition.macros.calories.value}
          </Typography>
        </div>
      )}

      <div className="flex flex-col items-center">
        <Typography variant="subtitle1" className="font-medium">
          Servings
        </Typography>
        <Typography variant="subtitle2" className="font-normal">
          {recipe.servings}
        </Typography>
      </div>
      <div className="flex flex-col items-center">
        <Typography variant="subtitle1" className="font-medium">
          Total Time
        </Typography>
        <Typography variant="subtitle2" className="font-normal">{`${calculateTotalTime(recipe)} mins`}</Typography>
      </div>
    </div>
  );
};

export default RecipeQuickNutrition;
